export default __webpack_public_path__ + "static/media/spa.d416bd4d.jpg";